import { useFeatureIsOn, useFeatureValue } from '@growthbook/growthbook-react';
import {
  FEATURE_FLAGS,
  FEATURE_FLAGS_TYPE,
} from 'src/utils/growthBook/growthBook.constants';
import { AppSubdomains } from 'src/types/common';
import { getSubdomain } from 'src/utils/domain/getSubdomain';

type SubdomainFlagKey = keyof {
  [K in keyof FEATURE_FLAGS_TYPE as FEATURE_FLAGS_TYPE[K] extends {
    [key in AppSubdomains]: boolean;
  }
    ? K
    : never]: FEATURE_FLAGS_TYPE[K];
};

export function useGrowthbookSubdomainFlags(
  flag: SubdomainFlagKey,
  fallback: boolean
): boolean {
  const subdomain = getSubdomain(AppSubdomains, AppSubdomains.Pari);
  const isEnabled = useFeatureIsOn(FEATURE_FLAGS[flag]);
  const flagValue = useFeatureValue<FEATURE_FLAGS_TYPE[typeof flag]>(
    FEATURE_FLAGS[flag],
    {
      [AppSubdomains.Homebar]: fallback,
      [AppSubdomains.Terea]: fallback,
      [AppSubdomains.Pari]: fallback,
    }
  );

  return (
    isEnabled &&
    (typeof flagValue === 'object' ? flagValue[subdomain] : flagValue)
  );
}
